import axios from 'axios';
import React from 'react';

import Button from 'plaid-threads/Button';
import Label from 'plaid-threads/Label';
import Text from 'plaid-threads/Text';
import TextInput from 'plaid-threads/TextInput';

import './index.scss';
import { AppContext } from '../App';
import Whitespace from '../components/Whitespace';
import { CountryCode } from '../constants';
import { InternalOptions } from '../types';

interface UpdateModeProps {}

const UpdateMode: React.FC<UpdateModeProps> = () => {
  const { countryCode, forceDesktop } = React.useContext(AppContext);
  const [accessToken, setAccessToken] = React.useState<string>('');
  const [isRunning, setIsRunning] = React.useState<boolean>(false);

  function onStartClick() {
    if (isRunning) {
      return;
    }

    setIsRunning(true);

    startUpdateMode(accessToken, countryCode, forceDesktop)
      .catch((err) => {
        console.error(err);
      })
      .then(() => {
        setIsRunning(false);
      });
  }

  return (
    <div className="UpdateMode">
      <div className="UpdateMode__title">Update Mode</div>
      <Text contrast="low">
        Provide an <Label noIcon>Access token</Label> and click{' '}
        <Label noIcon>Start</Label>. Or leave it empty if you are already logged
        in.
      </Text>
      <div className="UpdateMode__input">
        <TextInput
          value={accessToken}
          id="update_mode_access_token"
          label="Access token"
          onChange={(e) => setAccessToken(e.currentTarget.value)}
        />
        <Whitespace width="2rem" />
        <Button inline centered disabled={isRunning} onClick={onStartClick}>
          Start
        </Button>
      </div>
    </div>
  );
};

export function startUpdateMode(
  accessToken: string,
  countryCode: Array<CountryCode>,
  forceDesktop: boolean,
): Promise<null> {
  const internalOptions: InternalOptions = {};
  if (forceDesktop) {
    internalOptions.forceDesktop = true;
  }

  return axios
    .post(
      `${process.env.REACT_APP_SERVER_URL}/token/create_link_token`,
      { countryCode, access_token: accessToken, force: true },
      { withCredentials: true },
    )
    .then((response) => {
      if (!response.data.link_token) {
        throw new Error('No link token');
      }

      return new Promise((resolve) => {
        // @ts-ignore
        let plaidLink = Plaid.create(
          {
            token: response.data.link_token,
            // @ts-ignore
            onSuccess: () => {
              plaidLink = undefined;
              resolve(null);
            },
            // @ts-ignore
            onExit: () => {
              plaidLink = undefined;
              resolve(null);
            },
            // // @ts-ignore
            // onEvent: () => {},
          },
          internalOptions,
        );
        plaidLink.open();
        // Change Link's zIndex so the demo banner can be seen
        const iframes = Array.from(document.getElementsByTagName('iframe'));
        iframes.forEach((iframe) => (iframe.style.zIndex = '2147483646'));
      });
    });
}

export default UpdateMode;
